import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../api/api-client";

interface getFilesPayload {
  filename: string;
  database: string;
  username: any;
  userNameEmail: any;
}

const getFilesApiPayload = (data: getFilesPayload): getFilesPayload => {
  return {
    username: data.username,
    userNameEmail: data.userNameEmail,
    filename: data.filename,
    database: data.database,
  };
};

export function useGetFileMutation() {
  return useMutation({
    mutationFn: async (data: getFilesPayload) => {
      const payload = getFilesApiPayload(data);

      const response = await apiClient.apiFilePost(
        "/wrapper/get-files",
        payload,
        false,
        "blob"
      );
      return response as any;
    },
  });
}
